import { JOGGResponse, JoggCart } from "@jog/types"

import { handleCartError } from "../helper"
import { JoggApiOption } from "./client"

export const validateCartBase =
    ({ client }: Pick<JoggApiOption, "client">) =>
    async <S extends JOGGResponse<{ actionList: JoggCart["cartMessage"] }>>(cartId: string): Promise<S> => {
        const request = () =>
            client.execute({
                method: "PUT",
                uri: `/ctp/carts/view/${cartId}`,
            })
        return handleCartError(request, 5)
    }
